































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IKeyValues} from '@/interfaces/key-value-interface';
import ReportPlaceHolder from '@/modules/neodash/components/report-placeholder/report.placeholder.vue';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import {i18nMixin, tableMixin} from '@/modules/neodash/mixins';
import {PRINT_TOGGLE_TABLE_MODE} from '@/store/modules/print/types';
import moment from 'moment';

@Component({
  name: 'ReportVueContainer',
  components: {
    ReportPlaceHolder,
    ReportAppBar
  }
})
export default class ReportVueContainer extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  @Prop({required: true})
  public showReport: boolean;

  @Prop({required: true})
  public keyNameReport: string;

  @Prop({required: true})
  public labelFilters: IKeyValues;

  @Prop({required: false})
  public fileNameExport: string;

  @Prop({required: false, default: false})
  public interceptExportToExcel: boolean;

  public printReport(): void {
    window.print();
  }

  public exportToExcel(): void {
    if (this.interceptExportToExcel) {
      this.$emit('exportToExcel');
      return;
    }

    this.$store.dispatch(PRINT_TOGGLE_TABLE_MODE);
    setTimeout(() => {
      const {fileNameExport, translate, keyNameReport} = this;
      const nameReport = fileNameExport || translate(keyNameReport);
      const dateExport = moment().format('YYYYMMDD-HHmmss');

      const html = (this.$refs.reportContent as any).children[0].outerHTML;
      tableMixin.methods.exportHtmlToExcel(html, `${nameReport} - ${dateExport}.xls`);
      this.$store.dispatch(PRINT_TOGGLE_TABLE_MODE);
    }, 300);
  }
}
